import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import pic_06 from './Assets/pic_06.webp';
import pic_07 from './Assets/pic_07.webp';
import pic_08 from './Assets/pic_08.webp';
import pic_09 from './Assets/pic_09.webp';
import ambassadorImage from './Assets/GordonGlenister.png';

export const ambassador = {
  name: 'Gordon Glenister',
  position: 'left',
  description: <>
    <p>
      I started in the industry in 2018 by forming the influencer division of the Branded Content Marketing Association.
      I then went on to create the Influence Global Podcast, which now has over 170 episodes.
      I am also the author of Influencer Marketing Strategy, which was a finalist in the Business Book of the Year Awards, and the 2nd edition was released in 2024.
      I also made a documentary film on influencer marketing for the Brazilian market in 2022. In 2021, we launched an influencer marketing project over three years, involving 1,500 marketing students and 60 brands to help educate both brands and students about the power of influencer marketing.
      I have developed top 100 most influential people indices for associations over the last five years. As an influencer myself, I have spoken at or moderated panels at over 300 events in recent years. In 2025, I will launch Employfluence, an agency and platform devoted to leveraging employees as influencers.
      I am passionate about helping individuals build their personal brand and influence. Find out more at <a href="https://www.gordonglenister.com/" target="_blank">www.gordonglenister.com</a>.
    </p>
  </>,
  image: ambassadorImage,
  socialLinks: {
    instagram: 'javascript:void(0)',
    youtube: 'javascript:void(0)',
    twitter: 'javascript:void(0)',
    tiktok: 'javascript:void(0)',
  },
};

export const EpochInfo = {
  title: 'RISE OF BLOGGING',
  period: '986-2000',
  description: <>
    <p>
      Enter a revolutionary era of pioneering digital expression, bridging the gap between the pre-Connectivity Age and the Connectivity Age. This hall showcases the birth of online journals, later known as blogs, created by early web enthusiasts. It was a time of vibrant experimentation and new internet jargon, marking the dawn of what would become the Era of the Internet, a.k.a. the Computer Age or Electronic Age.
    </p>
  </>,
};

export const events = [
  {
    year: '986-1001',
    title: 'The Pillow Book',
    content: (
      <>
        <p>
          Some scholars believe that "The Pillow Book," written by the Japanese court lady Sei Shōnagon in the late 10th century, was the first ever written blog about everything. Zuihitsu, which literally means "follow the brush," is a type of personal diary in which the author writes whatever comes to their mind without following a specific chronology.
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|68p[b9F0g~AIpJD#ktREL4.S$s:%2%1IUbb$*ofD+-oob9axas-Nxnis.IpaxxaIVWY%KniI:bHocRl$%xZIqjFt5NHjYxuV@j[t7IVt7t5RlWCRkaxS4jcxsS4Rj%0R+jYozM{M{xuRkWYxYofWSafjvx[soIUNws.oe',
    picName: 'pic_01',
  },
  {
    year: '1520',
    title: 'Der Kleidernarr',
    content: (
      <>
        <p>
          Matthäus Schwarz, a German accountant passionate about fashion, is renowned as the world's first fashion blogger. At 25, with aspirations of becoming a celebrity, Matthäus began documenting his unique style. He collaborated with the talented artist Narziss Renner to create the "Klaidungsbüchlein" or "Book of Clothes," which featured 137 exquisite watercolor sketches and detailed descriptions of Matthäus's outfits. This pioneering work set the stage for a new era in fashion storytelling!
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|FD8%p9t5W=|V@~BEMSi^PsmNHRj-UIps.oeE2xGoMIot6s:I:WBjZWVWVNHxZxYofNHoJs:WVofRks:s.WBogR*ofs.WVxaR*NHs-axt7WUayWCWVWWjZs.WWR*oKWBbHs.jZWXR*WVayays.ayNHfks.ofayj@ofWVj]',
    picName: 'pic_02',
  },
  {
    year: '1994',
    title: 'Founding Father',
    content: (
      <>
        <p>
          Justin Hall, dubbed the "founding father of personal blogging," launched Justin's Links from the Underground in 1994. His blend of personal narratives and curated links was groundbreaking, earning recognition from The New York Times Magazine in 2004. Hall encouraged others to share their stories, fostering a community that laid the groundwork for the personal blogging movement.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|49GdRr;011Q03$d~VwIIVEgxZsoIpj@%1oeIpR+00XT^+vy^*%f9FNyoz=xIqIp%1%1RjNH%2jFlAwHn3yDD*9a-;WAjE%1NH%0xZ9aR.xaoHxtH?kXx]R5-oS$9G%L-o0gxaxZfhxuV@niX9Rj-;9aM{?aaxV@xuIpIW',
    picName: 'pic_03',
  },
  {
    year: '1997',
    title: 'Weblog formula',
    content: (
      <>
        <p>
          In 1997, Jorn Barger launched his groundbreaking website, Robot Wisdom, which was notable for its innovative approach to sharing links to various internet resources. It was on this website that Barger introduced the term "web log" to describe his creation. Before long, the two words blended into one, giving rise to a new phenomenon. A few years later, Peter Merholz playfully transformed "weblog" into "we blog," signifying a shift toward personal storytelling. This catchy phrase quickly gained traction, leading to the birth of "blogs," while those who wrote these online diaries became known as "bloggers."
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|6A9i?n304tRnhAIM{^i-nAwIV%0%LV@t7e-j]R+AIWAxGofxXRlNHozxD^O-T9wIqxZIqR*%1t50OIp~9%0afxYj?I@E3~ARjENofkBs;M|ofs.%1wvWXI=NH%2wIWCX80hNG^ixFNGxtjrIpWD-SxZI@IpaebbjZxExZ',
    picName: 'pic_04',
  },
  {
    year: '1998',
    title: 'Career Hurricane',
    content: (
      <>
        <p>
          In 1998, journalist Jonathan Dube documented the impact of Hurricane Bonnie in North Carolina for The Charlotte Observer. His compelling storytelling led him to become a trailblazer in digital journalism. Dube's work inspired The New York Times to launch its first online journal, and he later became its chief editor. Today, he is celebrated as a pioneering digital director and blogger who achieved success in American online media, showcasing the influence of innovative storytelling.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|8E.e3}k0O~V%LM{XnRO-.IrIAIqkARQa|t7j?Rk01Ny]i9aIpxurpo}IBxuxtxUgNtQt7adWEWBIBRkXmkDr;V[ItM|%fV[RjWqaeWXR,Rkslxax]t5$yxtNKV@%MxsVZIVWVxut7RQoIt7WEe.xYWCIVRjyCofVso0S~',
    picName: 'pic_05',
  },
  {
    year: '1999',
    title: 'Blogiverse Is No Joke',
    content: (
      <>
        <p>
          In 1999, Brad Graham joked, “Goodbye, cyberspace! Hello, blogiverse!” This catchy phrase introduced the idea of the "blogiverse," a lively space filled with blogs where people could search for information, share ideas, and express their opinions.
        </p>
      </>
    ),
    img: pic_06,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_06',
  },
  {
    year: '2000',
    title: 'Catalog',
    content: (
      <>
        <p>
          How can bloggers and readers truly connect if their blogs aren’t part of a single social network? This question led Jesse James Garrett to create a catalog of similar web pages, curated based on his personal interests in content and the consistency of posts. He organized these blogs into categories for easier navigation. To maintain its historical significance, Garrett hasn’t made any changes to this page since its last update on October 12, 2000.
        </p>
      </>
    ),
    img: pic_07,
    blurhash: '|6BCuwL302=xyCIoQ-$yO?}mNG58wu%KadRPbGxY00R4^ibHwIowozS2wH1P$*=^t7VaI;tQn%IqEj?H^*ENE2s9kWxHI;DhIT$gENNt-Aa$n%od?GIpDjxWx[WFn4R*xutRxuxus:S4WYWES%t79aoI-oRkIoxttQM|i_',
    picName: 'pic_07',
  },
  {
    year: '2000',
    title: 'Journey to Los Angeles',
    content: (
      <>
        <p>
          Adam Kontras is recognized as the pioneer of video blogging, launching The Journey on January 2, 2000, on his personal website. His first video, a playful 15-second clip of sneaking a cat into his apartment, documented his move from Columbus, Ohio, to Los Angeles for a career in show business. Despite being considered a veteran of the format, Kontras still posts regularly, making The Journey the longest-running video blog in history. His innovative approach has significantly influenced the evolution of online content creation.
        </p>
      </>
    ),
    img: pic_08,
    blurhash: '|bGuzWx^tmRiIUayIURjaK?wtmkDRjRjofafRjaeD*o#M{kCxut7t7WAofD%t7RijZtRWBjsoJa#NHWUe-RjbHV@jEjYa#ozM{aeaeofoeWAV@V@ogV@e.jakCflf5WBWBaxofWBayofayj[fRofWBj]ayoMjsoeWAj[kC',
    picName: 'pic_08',
  },
  {
    year: '2000',
    title: 'Who Invented Vlogging?',
    content: (
      <>
        <p>
          Adrian Miles is a significant figure in vlogging history, credited with coining the term "vlog." In November 2000, he posted a video featuring changing text on a still image, marking a pivotal moment for video blogging. This innovative concept laid the groundwork for what would become a widely embraced and impactful method of storytelling online.
        </p>
      </>
    ),
    img: pic_09,
    blurhash: '|MC~@q%Ls.S4R*jYNHt6jZ_MbboJkCWCWCfkt6f6.7t7WVf+aeoes:WCWVTKt7WBW=afa}ofWCR+tRxtRkf+jZR+WXWWjZo}xtWCkCj[WCWWWWjsozt6s-oefkWCoLj[ayt7t6s.oLWVWBj@azo0s:fPj?oeofa#a|oejZ',
    picName: 'pic_09',
  },
];